import React from 'react';
import styled from 'styled-components';
import FeedbackHeader from './FeedbackHeader';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactProgress from 'shared/design-system/components/TrueImpactProgress';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { FeedbackStatus } from 'donor/portal/pages/FeedbackDashboard/api';
import { UserType } from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';

interface FeedbackOverviewProps {
  userType: UserType;
  showHeader?: boolean;
  totalFeedbacks: number;
  feedbackStatus: FeedbackStatus;
  numberOfCompletedFeedback: number;
  handleDone: () => unknown;
  handleStart: () => unknown;
}

const StyledDiv = styled.div<{ showHeader?: boolean }>`
  padding: ${SPACERS.extraLarge} 30px;
  .feedback-progress {
    max-width: 368px;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    padding-top: ${({ showHeader }) => (showHeader ? SPACERS.large : 0)};
  }
`;

const FeedbackOverview: React.FC<FeedbackOverviewProps> = ({
  userType,
  showHeader,
  totalFeedbacks,
  feedbackStatus,
  numberOfCompletedFeedback,
  handleDone,
  handleStart,
}) => {
  return (
    <StyledDiv showHeader={showHeader}>
      {showHeader && (
        <FeedbackHeader
          userType={userType}
          feedbackStatus={feedbackStatus}
          totalFeedbacks={totalFeedbacks}
          numberOfCompletedFeedback={numberOfCompletedFeedback}
          handleDone={handleDone}
          handleStart={handleStart}
        />
      )}
      <div className="feedback-progress">
        <TrueImpactText variant="heading-label">
          Feedback Progress
        </TrueImpactText>
        <TrueImpactProgress
          color="success"
          total={totalFeedbacks}
          completed={numberOfCompletedFeedback}
        />
      </div>
    </StyledDiv>
  );
};

export default FeedbackOverview;
